var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanFeatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star/filled/thinsmooth"
  }, /*#__PURE__*/React.createElement("path", {
    id: "star/simple/thinsmooth",
    d: "M10 0C10.1952 5.43992 14.5601 9.80475 20 10C14.5601 10.1952 10.1952 14.5601 10 20C9.80475 14.5601 5.43992 10.1952 0 10C5.43992 9.80475 9.80475 5.43992 10 0Z",
    fill: "#4D4D4D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanFeatureIcon);
export default __webpack_public_path__ + "static/media/plan-feature-icon.31ae9957900222ae208a0eb8b2ce8b34.svg";
export { ForwardRef as ReactComponent };